import { Dropdown, Space } from 'antd';
import { ArrowDownIcon } from 'icons';
import Image from 'next/image';
import { useRouter } from 'next/router';

const LanguageDropdown = () => {
  const router = useRouter();
  const { pathname, asPath, query, locale = 'uz' } = router;

  const handleLanguageChange = (locale: string) => {
    router.push({ pathname, query }, asPath, { locale });
  };

  const items = [
    {
      key: 'uz',
      label: (
        <Space>
          <div className="relative h-2 w-3.5">
            <Image fill src="/images/uz-flag.webp" alt="Uz Flag" title="O'zbek tili" />
          </div>
          UZ
        </Space>
      ),
      onClick: () => handleLanguageChange('uz')
    },
    {
      key: 'ru',
      label: (
        <Space>
          <div className="relative h-2 w-3.5">
            <Image fill src="/images/ru-flag.webp" alt="Uz Flag" title="O'zbek tili" />
          </div>
          RU
        </Space>
      ),
      onClick: () => handleLanguageChange('ru')
    }
  ];

  return (
    <Dropdown menu={{ items }} trigger={['click']}>
      <div className="lg:min-w-18 flex h-9 cursor-pointer items-center gap-1 rounded-lg bg-gray-100 px-3.5 text-sm font-medium text-gray-700">
        <div className="w-4.5 relative h-3">
          <Image
            fill
            src={locale === 'ru' ? '/images/ru-flag.webp' : '/images/uz-flag.webp'}
            alt="Uz Flag"
            title="O'zbek tili"
          />
        </div>
        <span className="max-lg:hidden">{locale.toUpperCase()}</span>
        <div className='hidden sm:block'>
          <ArrowDownIcon />
        </div>
      </div>
    </Dropdown>
  );
};

export default LanguageDropdown;
